var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',_vm._b({attrs:{"options":_vm.countries,"custom-label":function (ref) {
	var code = ref.code;
	var name = ref.name;

	return (name + " (" + code + ")");
},"track-by":"name","placeholder":_vm.$attrs.placeholder || 'Select a Country',"show-labels":false,"allow-empty":false,"open-direction":"above"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'multiselect',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }